import { defineMessages } from "react-intl";

export const MESSAGES = defineMessages({
  selectFundingTitle: {
    id: "funding-application: select funding",
    defaultMessage: "Select funding",
  },
  requestedAmountInvalidError: {
    id: "funding-application: funding amount is invalid",
    defaultMessage: "Please enter a positive, non-zero number",
  },
  requestedAmountError: {
    id: "funding-application: funding amount is required",
    defaultMessage: "Please enter a valid funding amount.",
  },
  intendedUseError: {
    id: "funding-application: funding use is required",
    defaultMessage: "Please select a use for funding.",
  },
  intendedUseMarketing: {
    id: "funding-application: funding use option marketing",
    defaultMessage: "Marketing",
  },
  intendedUseInventory: {
    id: "funding-application: funding use option inventory",
    defaultMessage: "Inventory purchasing",
  },
  intendedUseImproveCashflow: {
    id: "funding-application: funding use option improving cash flow",
    defaultMessage: "Improving cash flow",
  },
  intendedUseResearchDevelopment: {
    id: "funding-application: funding use option research development",
    defaultMessage: "Research and development",
  },
  intendedUseBusinessExpansion: {
    id: "funding-application: funding use option business expansion",
    defaultMessage: "Company expansion",
  },
  intendedUseOther: {
    id: "funding-application: funding use option other",
    defaultMessage: "Other",
  },
  intendedUseOtherSpecify: {
    id: "funding-application: funding use option other please specify",
    defaultMessage: "Please specify",
  },
  howMuchFundingLabel: {
    id: "funding-application: how much funding label",
    defaultMessage: "How much funding are you looking for?",
  },
  howMuchFundingHelperText: {
    id: "funding-application: how much funding helper text",
    defaultMessage: "You can request less than you’re eligible for and choose different currencies",
  },
  reasonForFundingLabel: {
    id: "funding-application: funding reason label",
    defaultMessage: "What's this funding for?",
  },
  reasonForFundingHelperText: {
    id: "funding-application: funding reason helper text",
    defaultMessage: "Select all that apply",
  },
  fundsDeploymentPreferenceLabel: {
    id: "funding-application: funds deployment preference label",
    defaultMessage: "When would you like to receive the funds?",
  },
  preferredFundsDeploymentChoiceAsap: {
    id: "funding-application: preferred funds deployment choice asap",
    defaultMessage: "As soon as possible",
  },
  preferredFundsDeploymentChoiceSpecificDate: {
    id: "funding-application: preferred funds deployment choice specific date",
    defaultMessage: "On a specific date",
  },
  preferredFundsDeploymentDateLabel: {
    id: "funding-application: preferred funds deployment date label",
    defaultMessage: "Choose a date",
  },
  preferredFundsDeploymentDateError: {
    id: "funding-application: preferred funds deployment date error",
    defaultMessage: "Please select the date you would like to receive the funds",
  },
});
